export const loadTranslations = importWithFallback(importTranslations);
export const loadTPATranslations = importWithFallback(importTPATranslations);
export const loadLocaleDataset = importWithFallback(importLocaleDataset);
async function importTranslations(locale) {
    const messages = await import(`../assets/locale/messages_${locale}.json`);
    return messages.default;
}
async function importTPATranslations(locale) {
    const messages = await import(`../assets/locale/messages-tpa_${locale}.json`);
    return messages.default;
}
async function importLocaleDataset(locale) {
    const messages = await import(`@wix/locale-dataset-data/resources/translations/messages_${locale}.json`);
    return messages.default;
}
function importWithFallback(importMessages) {
    return async (locale) => {
        try {
            const messages = await importMessages(locale);
            return messages;
        }
        catch (_error1) {
            try {
                const messages = await importMessages('en');
                return messages;
            }
            catch (_error2) {
                const empty = {};
                return empty;
            }
        }
    };
}
//# sourceMappingURL=load-translations.js.map